<template>
  <div class="member_v2_wrap" :style="bgStyle" :class="'bg_banner'">
    <!--  banner 间距控制 -->
    <memberBanner />
    <!-- 会员卡片 已开通展示 -->
    <memberCard v-if="!isNewUserStatus" :headInfo="headInfo" :membership="membership" />
    <!-- 暂停信息条-->
    <pauseStatusBar v-if="isPauseStatus" :membership="membership" />
    <!-- 
      权益相关 
      memberBox：新客有圆角 老客无圆角、无背景色（取父组件背景色）
      benefitList：新客菜卡颜色灰色  老客菜卡颜色白色
    -->
    <memberBox>
      <!-- 权益大卡-权益平铺 -->
      <template v-if="isBenefitFlatMode">
        <memberTitle :title="$t('FoodC_update_LeTO_aqit' /**会员权益 */)" />
        <benefitList :benefitInfo="benefitInfo" :benefitList="benefitInfo.content" />
      </template>
      <!-- 权益大卡、小卡-权益主次 -->
      <template v-else>
        <memberTitle :title="$t('FoodC_update_LeTO_aqit' /**会员权益 */)" />
        <benefitList :benefitInfo="benefitInfo" :benefitList="mainBenefit" />
        <template v-if="subBenefit && subBenefit.length > 0">
          <memberTitle :title="$t('FoodC_update_WqVL_CaFf' /**更多权益 */)" />
          <benefitList size="small" :benefitInfo="benefitInfo" :benefitList="subBenefit" />
        </template>
      </template>
      <!-- 管理入口 -->
      <template v-if="!isNewUserStatus">
        <memberTitle :title="$t('FoodC_update_QQlM_iHYO' /**设置 */)" />
        <manageEntry :membership="membership" />
      </template>
      <!-- 预计可省 -->
      <template v-if="isNewUserStatus">
        <savingInfo :saleInfo="saleInfo" class="saving_info_style" />
      </template>
    </memberBox>

    <!-- 底部已订阅文案条 - 会员老客-已开通&已订阅展示  -->
    <subscribeText v-if="isShowSubscribeText" :membership="membership" />
    <div v-else :style="{ paddingTop: '160px' }"></div>
    <!-- footer -->
    <memberFooter :headInfo="headInfo" />
  </div>
</template>

<script>
import memberBanner from '@/page/member/components-v2/member-banner.vue'
import memberTitle from '@/page/member/components-v2/member-title.vue'
import memberBox from '@/page/member/components-v2/member-box.vue'
import memberCard from '@/page/member/components-v2/member-card.vue'
import benefitList from '@/page/member/components-v2/benefit/benefit-list.vue'
import pauseStatusBar from '@/page/member/components-v2/pause-status-bar.vue'
import savingInfo from '@/page/member/components-v2/saving-info.vue'
import manageEntry from '@/page/member/components-v2/manage-entry.vue'
import subscribeText from '@/page/member/components-v2/subscribe-text.vue'
import memberFooter from '@/page/member/components-v2/member-footer.vue'
import { MEMBER_STATUS } from '@/page/member/common/enumsUtil.js'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberEntryV2',
  components: {
    memberCard,
    benefitList,
    pauseStatusBar,
    savingInfo,
    manageEntry,
    subscribeText,
    memberFooter,
    memberBanner,
    memberBox,
    memberTitle,
  },
  mixins: [mixin],
  props: {
    pageInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    membership() {
      return this.pageInfo?.membership || {}
    },
    headInfo() {
      return this.pageInfo?.headInfo || {}
    },
    benefitInfo() {
      return this.pageInfo?.benefitInfo || {}
    },
    saleInfo() {
      return this.pageInfo?.saleInfo || {}
    },
    // 已订阅文案展示
    isShowSubscribeText() {
      return this.memberStatus === MEMBER_STATUS.oldBuySubscription
    },
    // 背景样式
    bgStyle() {
      const banner = this.headInfo?.atmosphereImageUrl
      let backgroundColor = ''

      if (this.memberStatus !== MEMBER_STATUS.newNoBuy) {
        backgroundColor = '#f5f5f7'
      }

      return {
        backgroundImage: `url(${banner})`,
        backgroundColor,
      }
    },
    // 主权益 （主次权益时用到）
    mainBenefit() {
      const mainList = this.membership?.mainBenefitItemTypeList || []
      const info = this.benefitInfo?.content.filter(item => {
        return mainList.includes(item.itemType)
      })
      return info
    },
    // 次权益（主次权益时用到）
    subBenefit() {
      const mainList = this.membership?.mainBenefitItemTypeList || []
      const subInfo = this.benefitInfo?.content.filter(item => {
        return !mainList.includes(item.itemType)
      })
      return subInfo
    },
  },
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.member_v2_wrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
  &.bg_banner {
    background-size: 100%;
    background-repeat: no-repeat;
  }
}
.saving_info_style {
  padding-top: 48px;
  padding-bottom: 200px;
}
</style>
